import { httpsCallable } from "firebase/functions";
import { functions } from "../utils/firebase";

export async function loadAdminRevenue() {
  const fn = httpsCallable(functions, "adminGetRevenueDashboard");
  const { data } = await fn();
  return data;
}
